import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
export function useFilters() {
    const [clearFiltersMutation] = useMutation(gql `
    mutation ClearFilters {
      clearAllFilters @client
    }
  `);
    function clearAllFilters() {
        return clearFiltersMutation();
    }
    return {
        clearAllFilters
    };
}
//# sourceMappingURL=useFilters.js.map